import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/public/arrow_out.svg");
;
import(/* webpackMode: "eager" */ "/app/public/chains/arbitrum.svg");
;
import(/* webpackMode: "eager" */ "/app/public/chains/base.svg");
;
import(/* webpackMode: "eager" */ "/app/public/chains/bsc.svg");
;
import(/* webpackMode: "eager" */ "/app/public/chains/ethereum.svg");
;
import(/* webpackMode: "eager" */ "/app/public/chains/near.svg");
;
import(/* webpackMode: "eager" */ "/app/public/download-banner/download-banner.png");
;
import(/* webpackMode: "eager" */ "/app/public/public-qrcode.png");
;
import(/* webpackMode: "eager" */ "/app/public/rating.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/AppStoreButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/ChainAnimations/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/ChainDust/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/SectionLink/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/PageSection/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/Rating/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/DownloadBanner/styles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/shared/components/SupportedChains/ChainSideNav.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/shared/components/SupportedChains/styles.module.css");
